var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Cleanliness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 11.48c0 1.77-.1 3.53-.27 5.29a55.44 55.44 0 01-5.7 19.74 44.621 44.621 0 01-10.72 13.86 28.233 28.233 0 01-8.26 5 17.56 17.56 0 01-7.08 1.08 13.7 13.7 0 01-6.28-1.89c-3 3.24-5.61 7.22-5.94 11.45h-3c.28-4.66 2.73-8.93 5.89-12.57.22-.26.45-.53.68-.78a47.821 47.821 0 015.38-5l4.71-4.48L28.59 41l-9.7 9.22a13.86 13.86 0 01-1.44-8 16.09 16.09 0 014.36-9.38 29.458 29.458 0 018.25-5.61c3.75-1.85 7.63-3.41 11.47-5 6.9-2.97 9.84-2.83 19.72-10.75z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Cleanliness.f7a48e93.svg";
export { SvgK1Cleanliness as ReactComponent };